// 公用js，建议使用IIFE（立即执行函数）
(function () {
   document.write(
    `<script>
      (function(win, export_obj) {
        win['LogAnalyticsObject'] = export_obj;
        if (!win[export_obj]) {
            var _collect = function() {
                _collect.q.push(arguments);
            }
            _collect.q = _collect.q || [];
            win[export_obj] = _collect;
        }
        win[export_obj].l = +new Date();
      })(window, 'collectEvent')
    </script>`+
    '<script async src="https://lf3-data.volccdn.com/obj/data-static/log-sdk/collect/5.0/collect-rangers-v5.1.8.js"></script>'+
    '<script language=javascript src="../static/js/jquery.qrcode.min.js"></script>'+
    '<script language=javascript src="../static/js/crypto.js"></script>'+
    '<script language=javascript src="../static/js/jsencryptv2.js"></script>'+
    '<script language=javascript src="../static/js/encrypt.js"></script>'+
    '<link rel="stylesheet" href="../static/css/viewer.css">'
  );

  $(document).ready(function () {
    // 检查元素是否存在
    var videoElement = document.querySelector('.video video');
    if (videoElement) {
      // 禁用右键菜单
      videoElement.addEventListener('contextmenu', function (e) {
        e.preventDefault(); // 阻止右键菜单
      });

      // 禁用鼠标悬停时的下载提示
      videoElement.addEventListener('mouseover', function (e) {
        e.preventDefault(); // 阻止默认的鼠标悬停行为
      });
    }
  });

  window.collectEvent('init', {
    app_id: 20002352, // 参考2.1节获取，注意类型是number而非字符串
    channel_domain: 'https://collect.yineng.com.cn/track/api', // 设置数据上送地址
    log: false, // true:开启日志，false:关闭日志
    autotrack: false, // 全埋点开关，true开启，false关闭
  });
  // 此处可添加设置uuid、设置公共属性等代码
  window.collectEvent('start'); // 通知SDK设置完毕，可以真正开始发送事件了

  if ($('.last-page').length > 0) {
    var lastHref = $('.last-page').attr('href');
    var tempHref1 = lastHref.split('-')[0];
    var tempHref2 = lastHref.split('-')[1];
    var lastPageNum = parseInt(tempHref2.split('.')[0]);
    $('.yn-pagination .last-page').after(
      '<span class="page-num total-page-num" >共' +
        lastPageNum +
        '页</span><span class="page-num go-page"  style="cursor: pointer;">转到</span><span class="page-num" style="padding-left:5px;padding-right:5px;"><input name="pageinput" type="text" class="page-input" style="border:none; width:50px;  outline: none; text-align:center;"></span>'
    );
    $('.yn-pagination .go-page').on('click', function () {
      var pageNum = parseInt($('.page-input').val());

      if (pageNum === '') {
        alert('请输入页码！');
        return false;
      }
      if (isNaN(pageNum) || pageNum <= 0 || pageNum > lastPageNum) {
        alert('请输入正确页码！');
        return false;
      }
      toHref = tempHref1 + '-' + pageNum + '.html';
      window.location.href = toHref;
    });
  }
 // 下载列表
  var host = '';
  var downloadPath = '';
  var agent = navigator.userAgent.toLowerCase();

  // 根据点击按钮获取下载地址
  function getDownloadUrl($elem) {
    var downId = $elem.attr('down');
    switch (downId) {
      case '1':
        if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
          downloadPath = '/home/app/microlecturer/soft/?id=1';
        } else {
          downloadPath = '/home/app/microlecturer/soft/?id=3';
        }
        break;
      case '2':
        downloadPath = '/home/app/microlecturer/soft/?id=4';
        break;
      case '3':
        downloadPath = '/home/app/microlecturer/soft/?id=5';
        break;
      default:
        downloadPath = '/home/app/microlecturer/soft/?id=1';
        break;
    }
  }
   // 定义按钮点击处理函数
  async function handleDownloadClick(e) {
    e.preventDefault();
    var $btn = $(this);
    getDownloadUrl($btn);
    var way = $btn.attr('way');

    $.ajax({
      type: 'get',
      url: host + downloadPath,
      crossDomain: true == !document.all,
      data: {},
      success: function (res) {
        console.log(res);
        // 获取当前按钮所在的容器，以便找到对应的隐藏下载链接
        var el = $btn.closest('.download-buttons, .type');
        var data = res.result.data;
        $.ajax({
          type: 'get',
          url: data.record_url,
          success: function (subres) {
            // 执行下载
            var subData = subres.result.data;
            if (subData) {
              // 根据 way 字段匹配 subData 中的属性
              // way="download_url1" -> subData.download_url1
              // way="download_url2" -> subData.download_url2
              var downloadLink = subData[way];
              if (downloadLink) {
                 // 如果找不到隐藏的 down-url，尝试创建一个或直接跳转
                 var $downUrl = el.find('.down-url');
                 if ($downUrl.length === 0) {
                    // 如果是在 .type 容器里可能没有预置 down-url，或者直接用 window.location
                    window.location.href = downloadLink;
                 } else {
                    $downUrl.attr('href', downloadLink);
                    $downUrl.find('span').click();
                 }
              }
            }
          },
        });
      },
    });
    // 上报火山
    const encryptedResult = await hybridEncrypt({
      source: '9428cn太阳集团古天乐领讲官网',
      school_name: '9428cn太阳集团古天乐领讲'
    });
    window.collectEvent('install_click_download', encryptedResult);
  }

    $.getJSON('../config/config.json', function (data, textStatus, jqXHR) {
    host = data.host
    // 绑定点击事件
    $('.down-btn').on('click', handleDownloadClick);

    // 检查URL是否包含download-now，如果是则触发btn1点击
    if (window.location.href.indexOf('download-now') !== -1) {
      $('.btn1.down-btn').trigger('click');

      // 移除URL中的?download-now=true参数
      var cleanUrl = window.location.href.split('?')[0];
      window.history.replaceState({}, document.title, cleanUrl);
    }
  });
})();

//# sourceMappingURL=module.js.map
